export default __webpack_public_path__ + "static/media/add-circle.83f2ffe2.svg";